import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { AppConstant } from "src/app/app.constant";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DataResult } from "@progress/kendo-data-query";

@Injectable()
export class StudentIndividualReportService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl()
    }

    public getAllReportData(filters): Observable<DataResult> {
        return this.httpClient.post(`${this.apiUrl}/getIndividualStudentAssessment/`, filters).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
}
